/**
 * Created by spepa on 26.12.2022
 */

AchievementsConfig.registerExpedition("rapunzel3", {
    force: Forces.LANDMARK_DONOR_SLOT2,
    target: { code: "rpcustomermain0a", stage: 0 },
    donors: ["rpcustomermain0b", "rpcustomermain1a", "rpcustomermain1b", "rpcustomermain1c",
        "rpcustomermain2a", "rpcustomermain2b", "rpcustomermain2c", "rpcustomermain2d", "rpcustomermain3a",
        "rpcustomermain3b", "rpcustomermain3c", "rpcustomermain3d"]
});

CustomerRecipes.rapunzel3 = cleverapps.clone(CustomerRecipes.universal, true);
CustomerRecipes.rapunzel3.rpproducer0_0[0].ingredients[0] = {
    type: "rpresource",
    stage: 3,
    amount: 1
};
delete CustomerRecipes.rapunzel3.rpproducer0_0[0].ingredients[0].code;

CustomerRecipes.rapunzel3.rpproducer1_0[0].requiredUnits[0].code = "rpcustomermain0b";
CustomerRecipes.rapunzel3.rpproducer2_0[0].requiredUnits[0].code = "rpcustomermain1c";
CustomerRecipes.rapunzel3.rpproducer3_0[0].requiredUnits[0].code = "rpcustomermain2d";
CustomerRecipes.rapunzel3.rpcustomerbridge0_0[0].ingredients[0].type = "rpresource";
CustomerRecipes.rapunzel3.rpcustomerbridge0_0[0].ingredients[0].code = undefined;
CustomerRecipes.rapunzel3.rpcustomerbridge0_0[0].ingredients[0].amount = 3;
CustomerRecipes.rapunzel3.rpcustomerbridge1_0[0].requiredUnits[0].code = "rpcustomermain0b";
CustomerRecipes.rapunzel3.rpcustomerbridge2_0[0].requiredUnits[0].code = "rpcustomermain1c";
CustomerRecipes.rapunzel3.rpcustomerbridge3_0[0].requiredUnits[0].code = "rpcustomermain2d";

delete CustomerRecipes.rapunzel3.rpcustomermain0_0;
delete CustomerRecipes.rapunzel3.rpcustomermain1_0;
delete CustomerRecipes.rapunzel3.rpcustomermain2_0;
delete CustomerRecipes.rapunzel3.rpcustomermain3_0;

PassLevelsConfig.rapunzel3pass = [
    {
        energy: 20,
        task: {
            goal: 120
        },
        reward: {
            unit: { code: "worker", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "worker", stage: 2, amount: 1 }
        }
    }, // 1
    {
        energy: 20,
        task: {
            goal: 330
        },
        reward: {
            unit: { code: "sacks", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "sacks", stage: 1, amount: 1 }
        }
    }, // 2
    {
        energy: 20,
        task: {
            goal: 550
        },
        reward: {
            unit: { code: "wands", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "wands", stage: 2, amount: 1 }
        }
    }, // 3
    {
        energy: 20,
        task: {
            goal: 1100
        },
        reward: {
            unit: { code: "coins", stage: 2, amount: 1 }
        },
        premiumReward: {
            unit: { code: "rubies", stage: 3, amount: 1 }
        }
    }, // 4
    {
        energy: 20,
        task: {
            goal: 1700
        },
        reward: {
            unit: { code: "crystal", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "crystal", stage: 1, amount: 3 }
        }
    }, // 5
    {
        energy: 20,
        task: {
            goal: 2250
        },
        reward: {
            unit: { code: "treasure", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "treasure", stage: 2, amount: 1 }
        }
    }, // 6
    {
        energy: 20,
        task: {
            goal: 2800
        },
        reward: {
            unit: { code: "sacks", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "sacks", stage: 2, amount: 2 }
        }
    }, // 7
    {
        energy: 20,
        task: {
            goal: 3350
        },
        reward: {
            unit: { code: "herochest", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "herochest", stage: 1, amount: 3 }
        }
    }, // 8
    {
        energy: 20,
        task: {
            goal: 3350
        },
        reward: {
            unit: { code: "crystal", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "crystal", stage: 3, amount: 2 }
        }
    }, // 9
    {
        energy: 20,
        task: {
            goal: 3800
        },
        reward: {
            unit: { code: "herochest", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "herochest", stage: 2, amount: 2 }
        }
    }, // 10
    {
        energy: 20,
        task: {
            goal: 3800
        },
        reward: {
            unit: { code: "coins", stage: 2, amount: 1 }
        },
        premiumReward: {
            unit: { code: "treasure", stage: 2, amount: 2 }
        }
    }, // 11
    {
        energy: 20,
        task: {
            goal: 4295
        },
        reward: {
            unit: { code: "worker", stage: 2, amount: 1 }
        },
        premiumReward: {
            unit: { code: "worker", stage: 3, amount: 3 }
        }
    }, // 12
    {
        energy: 20,
        task: {
            goal: 4295
        },
        reward: {
            unit: { code: "magicplant", stage: 3, amount: 1 }
        },
        premiumReward: {
            unit: { code: "magicplant", stage: 5, amount: 1 }
        }
    }, // 13
    {
        energy: 20,
        task: {
            goal: 4600
        },
        reward: {
            unit: { code: "treasure", stage: 1, amount: 2 }
        },
        premiumReward: {
            unit: { code: "treasure", stage: 2, amount: 3 }
        }
    }, // 14
    {
        energy: 20,
        task: {
            goal: 4600
        },
        reward: {
            unit: { code: "wands", stage: 1, amount: 2 }
        },
        premiumReward: {
            unit: { code: "wands", stage: 3, amount: 3 }
        }
    }, // 15
    {
        energy: 20,
        task: {
            goal: 5050
        },
        reward: {
            unit: { code: "crystal", stage: 2, amount: 1 }
        },
        premiumReward: {
            unit: { code: "crystal", stage: 3, amount: 2 }
        }
    }, // 16
    {
        energy: 20,
        task: {
            goal: 5050
        },
        reward: {
            unit: { code: "coins", stage: 2, amount: 3 }
        },
        premiumReward: {
            unit: { code: "herochest", stage: 2, amount: 2 }
        }
    }, // 17
    {
        energy: 20,
        task: {
            goal: 5500
        },
        reward: {
            unit: { code: "worker", stage: 3, amount: 2 }
        },
        premiumReward: {
            unit: { code: "worker", stage: 4, amount: 2 }
        }
    }, // 18
    {
        energy: 20,
        task: {
            goal: 5500
        },
        reward: {
            unit: { code: "worker", stage: 4, amount: 1 }
        },
        premiumReward: {
            unit: { code: "magicplant", stage: 6, amount: 1 }
        }
    }, // 19
    {
        energy: 20,
        task: {
            goal: 5650
        },
        reward: {
            unit: { code: "coinstree", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "energytree", stage: 3, amount: 1 }
        }
    }, // 20
    {
        energy: 20,
        task: {
            goal: 5650
        },
        reward: {
            unit: { code: "coins", stage: 4, amount: 3 }
        },
        premiumReward: {
            unit: { code: "rubies", stage: 4, amount: 3 }
        }
    }, // 21
    {
        energy: 20,
        task: {
            goal: 5800
        },
        reward: {
            unit: { code: "herochest", stage: 2, amount: 2 }
        },
        premiumReward: {
            unit: { code: "herochest", stage: 2, amount: 3 }
        }
    }, // 22
    {
        energy: 20,
        task: {
            goal: 6100
        },
        reward: {
            unit: { code: "worker", stage: 4, amount: 2 }
        },
        premiumReward: {
            unit: { code: "magicplant", stage: 7, amount: 1 }
        }
    }, // 23
    {
        energy: 20,
        task: {
            goal: 6400
        },
        reward: {
            unit: { code: "magicplant", stage: 4, amount: 1 }
        },
        premiumReward: {
            unit: { code: "coinstree", stage: 3, amount: 1 }
        }
    }, // 24
    {
        energy: 20,
        task: {
            goal: 7000
        },
        reward: {
            unit: { code: "magicplant", stage: 5, amount: 1 }
        },
        premiumReward: {
            unit: { code: "energytree", stage: 3, amount: 2 }
        }
    } // 25
];

CustomerRecipes.rapunzel3.rpcustomermain0b_0 = [
    {
        ingredients: [{
            code: "rpproduct0",
            stage: 0,
            amount: 3
        }],
        requiredUnits: [{ code: "rpcustomermain0a", stage: 1 }]
    }
];
CustomerRecipes.rapunzel3.rpcustomermain1b_0 = [
    {
        requiredUnits: [{ code: "rpcustomermain1a", stage: 1 }],
        ingredients: [{
            code: "rpproduct1",
            stage: 0,
            amount: 3
        }]
    }
];
CustomerRecipes.rapunzel3.rpcustomermain1c_0 = [
    {
        requiredUnits: [{ code: "rpcustomermain1b", stage: 1 }],
        ingredients: [{
            code: "rpproduct1",
            stage: 0,
            amount: 3
        }]
    }
];
CustomerRecipes.rapunzel3.rpcustomermain2b_0 = [
    {
        requiredUnits: [{ code: "rpcustomermain2a", stage: 1 }],
        ingredients: [{
            code: "rpproduct2",
            stage: 0,
            amount: 2
        }]
    }
];
CustomerRecipes.rapunzel3.rpcustomermain2c_0 = [
    {
        requiredUnits: [{ code: "rpcustomermain2b", stage: 1 }],
        ingredients: [{
            code: "rpproduct2",
            stage: 0,
            amount: 3
        }]
    }
];
CustomerRecipes.rapunzel3.rpcustomermain2d_0 = [
    {
        requiredUnits: [{ code: "rpcustomermain2c", stage: 1 }],
        ingredients: [{
            code: "rpproduct2",
            stage: 0,
            amount: 3
        }]
    }
];
CustomerRecipes.rapunzel3.rpcustomermain3b_0 = [
    {
        requiredUnits: [{ code: "rpcustomermain3a", stage: 1 }],
        ingredients: [{
            code: "rpproduct3",
            stage: 0,
            amount: 2
        }]
    }
];
CustomerRecipes.rapunzel3.rpcustomermain3c_0 = [
    {
        requiredUnits: [{ code: "rpcustomermain3b", stage: 1 }],
        ingredients: [{
            code: "rpproduct3",
            stage: 0,
            amount: 3
        }]
    }
];
CustomerRecipes.rapunzel3.rpcustomermain3d_0 = [
    {
        requiredUnits: [{ code: "rpcustomermain3c", stage: 1 }],
        ingredients: [{
            code: "rpproduct3",
            stage: 0,
            amount: 3
        }]
    }
];

CustomerRecipes.rapunzel3.rpcustomermain0a_0 = [
    {
        ingredients: [{
            code: "rpproduct0",
            stage: 0,
            amount: 3
        }]
    }
];
CustomerRecipes.rapunzel3.rpcustomermain1a_0 = [
    {
        requiredUnits: [{ code: "rpcustomermain0a", stage: 1 }],
        ingredients: [{
            code: "rpproduct1",
            stage: 0,
            amount: 3
        }]
    }
];
CustomerRecipes.rapunzel3.rpcustomermain2a_0 = [
    {
        ingredients: [{
            code: "rpproduct2",
            stage: 0,
            amount: 1
        }]
    }
];
CustomerRecipes.rapunzel3.rpcustomermain3a_0 = [
    {
        ingredients: [{
            code: "rpproduct3",
            stage: 0,
            amount: 1
        }]
    }
];
UnitsLibrary.CODES_BY_TAB.rapunzel3 = [
    ["rphero"],
    ["rpresource", "rporder"],
    [],
    ["rpsource"],
    ["rpchest"],
    []
];
UnitsLibrary.EXPEDITION_PREFIXES.rapunzel3 = "rp";

Mines.rpsource = function (level, unit) {
    if (unit.stage === 1) {
        return [
            {
                amount: 5,
                units: [
                    { code: unit.getResource(), stage: 1 }
                ]
            },
            {
                amount: 1,
                probabilities: [0.1],
                units: [
                    { code: "coins", stage: 1 }
                ]
            }
        ];
    }

    return [
        {
            amount: 4,
            units: [
                { code: unit.getResource(), stage: 0 },
                { code: unit.getResource(), stage: 1 }
            ]
        }
    ];
};

Mines.rpsourcegenerator = function () {
    return { openedType: "rpsource" };
};

PassLevelsConfig.rapunzelpass = [
    {
        energy: 20,
        task: {
            goal: 15
        },
        reward: {
            unit: { code: "worker", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "worker", stage: 1, amount: 1 }
        }
    }, // 1
    {
        energy: 20,
        task: {
            goal: 45
        },
        reward: {
            unit: { code: "sacks", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "sacks", stage: 1, amount: 1 }
        }
    }, // 2
    {
        energy: 20,
        task: {
            goal: 100
        },
        reward: {
            unit: { code: "wands", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "wands", stage: 2, amount: 1 }
        }
    }, // 3
    {
        energy: 20,
        task: {
            goal: 210
        },
        reward: {
            unit: { code: "coins", stage: 2, amount: 1 }
        },
        premiumReward: {
            unit: { code: "rubies", stage: 4, amount: 1 }
        }
    }, // 4
    {
        energy: 20,
        task: {
            goal: 430
        },
        reward: {
            unit: { code: "crystal", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "crystal", stage: 1, amount: 3 }
        }
    }, // 5
    {
        energy: 20,
        task: {
            goal: 900
        },
        reward: {
            unit: { code: "treasure", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "treasure", stage: 2, amount: 1 }
        }
    }, // 6
    {
        energy: 20,
        task: {
            goal: 1100
        },
        reward: {
            unit: { code: "sacks", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "sacks", stage: 2, amount: 1 }
        }
    }, // 7
    {
        energy: 20,
        task: {
            goal: 1300
        },
        reward: {
            unit: { code: "herochest", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "herochest", stage: 1, amount: 2 }
        }
    }, // 8
    {
        energy: 20,
        task: {
            goal: 1500
        },
        reward: {
            unit: { code: "crystal", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "crystal", stage: 3, amount: 2 }
        }
    }, // 9
    {
        energy: 20,
        task: {
            goal: 2100
        },
        reward: {
            unit: { code: "herochest", stage: 1, amount: 1 }
        },
        premiumReward: {
            unit: { code: "energytree", stage: 2, amount: 1 }
        }
    } // 10
];

cleverapps.styles.rapunzel3 = {
    miningAnimation: {
        x: { align: "center", dx: 0, leftDx: 0 },
        y: { align: "center", dy: 0 }
    }
};

ShopWindow.TABS.UNITS_EXPEDITION_RAPUNZEL3 = 31;

UnitsShop.SHOPS.rapunzel3 = [{
    tab: ShopWindow.TABS.UNITS_EXPEDITION_RAPUNZEL3,
    unit: { code: "rpshop", stage: 0 }
}];

UnitsShop.PRODUCTS[ShopWindow.TABS.UNITS_EXPEDITION_RAPUNZEL3] = {
    refreshTimeout: "6 hours",
    refreshPrice: 199,

    default: [{
        unit: {
            code: "rpfreechest",
            stage: 0,
            amount: 1
        },
        type: Product.TYPE_FREE,
        left: 1
    }, {
        unit: {
            code: "rpshopchest",
            stage: 0,
            amount: 1
        },
        left: 1,
        price: 99,
        type: Product.TYPE_HARD
    }, {
        unit: {
            code: "crystal",
            stage: 1,
            amount: 2
        },
        price: 390,
        type: Product.TYPE_SOFT,
        left: 1
    }, {
        unit: {
            code: "crystal",
            stage: 3,
            amount: 3
        },
        price: 550,
        type: Product.TYPE_HARD,
        left: 1
    }, {
        unit: {
            code: "rprapunzel",
            stage: 0,
            amount: 5,
            onlyIfOpen: true,
            onlyIfNotDone: true
        },
        price: 199,
        type: Product.TYPE_SOFT,
        left: 5
    }, {
        unit: {
            code: "rprapunzel",
            stage: 1,
            amount: 3,
            onlyIfOpen: true,
            onlyIfNotDone: true
        },
        price: 99,
        type: Product.TYPE_HARD,
        left: 3
    }, {
        unit: {
            code: "rpprincehero",
            stage: 0,
            amount: 5,
            onlyIfOpen: true,
            onlyIfNotDone: true
        },
        price: 199,
        type: Product.TYPE_SOFT,
        left: 5
    }, {
        unit: {
            code: "rpprincehero",
            stage: 1,
            amount: 3,
            onlyIfOpen: true,
            onlyIfNotDone: true
        },
        price: 99,
        type: Product.TYPE_HARD,
        left: 3
    }],

    line_template: [{
        unit: {
            stage: 3,
            amount: 1
        },
        codes: "rpresource",
        left: 5,
        price: 199,
        type: Product.TYPE_SOFT
    }, {
        unit: {
            stage: 1,
            amount: 2
        },
        codes: "rporder",
        left: 5,
        price: 249,
        type: Product.TYPE_SOFT
    }]
};

PixelsPlanner.AVAILABLE.rapunzel3 = {
    fog: "fog3"
};

PixelsSwarm.RAPUNZEL3 = "rapunzel3";

PixelsSwarmConfig[PixelsSwarm.RAPUNZEL3] = {
    pages: ["rapunzel3"],
    reward: [{
        units: [
            { currentType: "rpresource", stage: 0 }
        ]
    }]
};

cleverapps.styles.PixelView[PixelsSwarm.RAPUNZEL3] = cleverapps.overrideStyles(cleverapps.styles.PixelViewTemplate, {}, true);